import { motion } from 'framer-motion'; // Import Framer Motion
import Hero from './components/Hero';
import News from './components/News';
import SpecialNotices from './components/SpecialNotices';
import FeaturedVideos from './components/FeaturedVideos';
import PointsTable from './components/PointsTable';
import Summery from './components/Summery';
import BtclPartner from './components/BtclPartners';
import MainSponsor from './components/MainSponsor';
import UpcomingMatches from './components/UpcomingMatches';
import RecentResults from './components/RecentResults';
import HomeDivisions from './components/HomeDivisions';

function Home() {
    // Animation variants for fade-in effect
    const fadeIn = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 1 } }
    };
// Animation variant for coming from the bottom
const slideFromBottom = {
    hidden: { opacity: 0, y: 100 }, // Start from below
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: 'easeOut' } } // Slide up
};
    

    return (
        <div style={{ background: 'var(--bgMain)' }}>
            <motion.div
               id="main-slider-container"
               initial="hidden"
               animate="visible"
               variants={slideFromBottom}
            >
                <Hero />
            </motion.div>

            {/* Official Sponsor & Upcoming Matches (Before content container for better bleed control) */}
            <MainSponsor />

            {/* Home Divisions section */}
            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                <HomeDivisions />
            </motion.div>

            <UpcomingMatches />

            {/* Points Table – directly after Upcoming Matches */}
            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                <PointsTable />
            </motion.div>

            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                <RecentResults />
            </motion.div>

            {/* Special Notices – bento grid after Recent Results */}
            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                <SpecialNotices />
            </motion.div>

            <div style={{ maxWidth: 'var(--maxWidth)', margin: '0 auto', padding: '0px' }}>
                {/* Featured Videos Section */}
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                    <FeaturedVideos />
                </motion.div>

                {/* News Section */}
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                    <News />
                </motion.div>

                {/* Summary / Stats Section */}
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                    <Summery />
                </motion.div>

            </div>


            <div style={{ maxWidth: 'var(--maxWidth)', margin: '0 auto', padding: '0px' }}>
                {/* Partners Section */}
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
                    <BtclPartner />
                </motion.div>
            </div>
        </div>
    );
}

export default Home;